import { makeStyles } from '@material-ui/core/styles';
import { reach } from '@penji/style-guide';
import classNames from 'classnames';
import React from 'react';

// Marks verbatim from
// https://github.com/kualibuild/builder-ui/blob/4d5cd651/app/src/app.css#L60-L66
const CHECKBOX_CHECKED_MARK =
    "url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2212%22%20height%3D%229%22%20viewBox%3D%220%200%2012%209%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M4.92933%208.49933C4.53881%208.88985%203.90564%208.88985%203.51512%208.49933L0.404882%205.38909C0.0585418%205.04275%200.0585426%204.48123%200.404882%204.13489C0.75088%203.78889%201.31173%203.7885%201.65821%204.13401L4.22222%206.69088L10.3378%200.575329C10.686%200.227135%2011.2508%200.228133%2011.5978%200.577555C11.943%200.925236%2011.942%201.48665%2011.5956%201.83311L4.92933%208.49933Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E')";

const CHECKBOX_INDETERMINATE_MARK =
    "url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2214%22%20height%3D%223%22%20viewBox%3D%220%200%2014%203%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M2%201.5L12%201.5%22%20stroke%3D%22white%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%2F%3E%3C%2Fsvg%3E')";

const filledCheckboxStyle = {
    borderColor: 'transparent',
    backgroundColor: reach.colors['stone-950'],
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};

const useStyles = makeStyles({
    control: {
        position: 'relative',
        boxSizing: 'border-box',
        display: 'inline-block',
        width: 16,
        height: 16,
        backgroundColor: reach.colors['stone-50'],
        border: `1px solid ${reach.colors['medium-gray-300']}`,
        boxShadow: reach.shadows.xs,
        '.Mui-focusVisible &': {
            outline: `2px solid ${reach.colors['sky-700']}`,
            outlineOffset: 1,
        },
    },

    checkbox: {
        borderRadius: 2,
    },

    checkboxChecked: {
        ...filledCheckboxStyle,
        backgroundImage: CHECKBOX_CHECKED_MARK,
    },

    checkboxIndeterminate: {
        ...filledCheckboxStyle,
        backgroundImage: CHECKBOX_INDETERMINATE_MARK,
    },

    radio: {
        borderRadius: '50%',
        position: 'relative',
    },

    radioChecked: {
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: reach.colors['stone-950'],
        },
    },
});

export const ReachCheckboxIcon = () => {
    const classes = useStyles();

    // https://github.com/kualibuild/builder-ui/blob/4d5cd651/app/src/app.css#L555-L557
    // input: https://github.com/kualibuild/builder-ui/blob/4d5cd651/app/src/ui/checkbox.jsx#L10-L20
    return <span className={classNames(classes.control, classes.checkbox)} />;
};

export const ReachCheckboxCheckedIcon = () => {
    const classes = useStyles();

    // https://github.com/kualibuild/builder-ui/blob/4d5cd651/app/src/app.css#L559-L562
    // input: https://github.com/kualibuild/builder-ui/blob/4d5cd651/app/src/ui/checkbox.jsx#L10-L20
    return (
        <span
            className={classNames(
                classes.control,
                classes.checkbox,
                classes.checkboxChecked,
            )}
        />
    );
};

export const ReachCheckboxIndeterminateIcon = () => {
    const classes = useStyles();

    // https://github.com/kualibuild/builder-ui/blob/4d5cd651/app/src/app.css#L566-L569
    // input: https://github.com/kualibuild/builder-ui/blob/4d5cd651/app/src/ui/indeterminate-checkbox.jsx#L25
    return (
        <span
            className={classNames(
                classes.control,
                classes.checkbox,
                classes.checkboxIndeterminate,
            )}
        />
    );
};

export const ReachRadioIcon = () => {
    const classes = useStyles();

    // https://github.com/kualibuild/builder-ui/blob/4d5cd651/app/src/ui/radios.jsx#L60-L66
    return <span className={classNames(classes.control, classes.radio)} />;
};

export const ReachRadioCheckedIcon = () => {
    const classes = useStyles();

    // https://github.com/kualibuild/builder-ui/blob/4d5cd651/app/src/ui/radios.jsx#L63-L66
    return (
        <span
            className={classNames(
                classes.control,
                classes.radio,
                classes.radioChecked,
            )}
        />
    );
};
